import {
  fetchLessonClassTaskFilters,
  fetchLessonClassTasks,
} from "classroom/api/teacher";
import { createClassroomTaskListStore } from "portfolio/stores/teacher/createClassroomTaskListStore";

export const useClassroomLessonClassTaskStore = createClassroomTaskListStore(
  "classroomLessonClassTask",
  {
    fetchList: (params, lessonClass) =>
      fetchLessonClassTasks(lessonClass, params),
    fetchFilters: (lessonClass) => fetchLessonClassTaskFilters(lessonClass),
  },
);
